import { CoreQuery } from "@gen/app-query";
import CircularProgress from "@mui/material/CircularProgress";
import Link from "@mui/material/Link";
import type { MouseEventHandler } from "react";
import { useState } from "react";

import { ActionDialog } from "~/components/action_dialog";
import { CopyableTextInput } from "~/components/copyable_text_input";

type ApiKeyProps = {
  clientId: string;
};

export function ApiKeyCell({ clientId }: ApiKeyProps) {
  const [isOpen, setOpen] = useState(false);
  const [isEnabled, setEnabled] = useState(false);

  const { data, isLoading } = CoreQuery.useAdmin_getClientApiKeyQuery(
    clientId,
    {
      enabled: isEnabled,
    },
  );

  const handleOpen: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.stopPropagation();
    setEnabled(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Link onClick={handleOpen} href="#">
        Show API Key
      </Link>
      {isOpen && (
        <ActionDialog
          heading="API Key"
          cancel={handleClose}
          cancelButtonMessage="Close"
        >
          {isLoading ? (
            <CircularProgress />
          ) : (
            <CopyableTextInput value={data?.api_key ?? ""} disabled />
          )}
        </ActionDialog>
      )}
    </>
  );
}
